import { initFollowBar } from "crosstalk-comments-livechat-sdk";
export function autoInitFollowBars() {
    const followDivs = document.querySelectorAll('div[data-crosstalk-follow-bar]');
    const followEmbeds = [];
    followDivs.forEach(followDiv => {
        const config = {
            wp: followDiv.dataset.wp || "",
            key: followDiv.dataset.key || "",
            theme: followDiv.dataset.theme || "light",
            isMono: followDiv.dataset.isMono === "true" ? true : false
        };
        const instance = initFollowBar(followDiv, config);
        if (instance)
            followEmbeds.push(instance);
    });
    return followEmbeds;
}
